import React, { useEffect } from "react";
import
  {
    TextInput,
    PasswordInput,
    Button,
    Card,
    Flex,
    Box,
    Text,
    Image,
    Center,
    Stack,
    Title,
    Alert,
    useMantineColorScheme
  } from "@mantine/core";
import md5 from "md5";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { HiOutlineShieldCheck, HiOutlineExclamationCircle } from "react-icons/hi";

import { useAuthStore } from "../../store/useAuthStore";
import ToggleButton from "../../components/ToggleButton";
import Logo from "../../assets/logo.png";
import { DASHBOARD } from "../../routes/types";

const Login = () =>
{
  const navigate = useNavigate();
  const { colorScheme } = useMantineColorScheme();
  const { login, autenticado, loading, message } = useAuthStore();

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Ingresa tu nombre de usuario"),
      password: Yup.string()
        .min(4, "Contraseña demasiado corta")
        .required("La contraseña es obligatoria"),
    }),
    onSubmit: async (formData) =>
    {
      const data = {
        username: formData.username,
        password: md5(formData.password),
      };
      const success = await login(data);
      if (success) {
        navigate(DASHBOARD);
      }
    },
  });

  useEffect(() =>
  {
    if (autenticado || localStorage.getItem('token')) {
      navigate(DASHBOARD);
    }
  }, [ autenticado, navigate ]);

  const isDark = colorScheme === 'dark';

  return (
    <Box h="100vh" bg={ isDark ? "dark.8" : "gray.0" } style={ { transition: 'background-color 0.3s ease' } }>
      <Box style={ { position: 'absolute', top: 20, right: 20, zIndex: 10 } }>
        <ToggleButton />
      </Box>

      <Center h="100%">
        <Stack w={ 400 } gap="xl">
          <Center>
            <Box p="lg" style={ {
              borderRadius: '50%',
              backgroundColor: 'white',
              border: `4px solid var(--mantine-color-yellow-5)`,
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
            } }>
              <Image src={ Logo } w={ 100 } h={ 100 } fit="contain" />
            </Box>
          </Center>

          <Card shadow="xl" radius="lg" p={ 0 } withBorder style={ {
            overflow: 'hidden',
            borderTop: `4px solid var(--mantine-color-yellow-5)`
          } }>
            <Stack p="xl" gap="md">
              <Box mb="md">
                <Title order={ 2 } ta="center" style={ { letterSpacing: '1px' } }>GC-COM ADMIN</Title>
                <Text c="dimmed" size="xs" ta="center" fw={ 700 } tt="uppercase" style={ { letterSpacing: '2px' } }>
                  Acceso de Operadores
                </Text>
              </Box>

              { message && (
                <Alert icon={ <HiOutlineExclamationCircle size={ 16 } /> } color="red" variant="light" radius="md">
                  { message }
                </Alert>
              ) }

              <form onSubmit={ formik.handleSubmit }>
                <Stack gap="md">
                  <TextInput
                    label="Nombre de Usuario"
                    placeholder="Tu usuario"
                    size="md"
                    radius="md"
                    { ...formik.getFieldProps('username') }
                    error={ formik.touched.username && formik.errors.username }
                  />

                  <PasswordInput
                    label="Contraseña"
                    placeholder="••••••••"
                    size="md"
                    radius="md"
                    { ...formik.getFieldProps('password') }
                    error={ formik.touched.password && formik.errors.password }
                  />

                  <Button
                    fullWidth
                    size="md"
                    radius="md"
                    color="yellow"
                    type="submit"
                    loading={ loading }
                    mt="md"
                    autoContrast
                    leftSection={ <HiOutlineShieldCheck size={ 18 } /> }
                  >
                    Entrar al Sistema
                  </Button>
                </Stack>
              </form>
            </Stack>

            <Box bg={ isDark ? "dark.7" : "gray.1" } p="xs">
              <Text size="10px" ta="center" c="dimmed" fw={ 700 }>
                SISTEMA DE MONITOREO Y GESTIÓN GC © 2026
              </Text>
            </Box>
          </Card>
        </Stack>
      </Center>
    </Box>
  );
};

export default Login;
